// (function() {
//     'use strict';

//     function Extras($http, $q) {
//         return {
//             name: 'extras',
//             checkCircle: function(circle) {
//                 var deferred = $q.defer();

//                 $http.get('/api/extras/example/' + circle).success(function(response) {
//                     deferred.resolve(response);
//                 }).error(function(response) {
//                     deferred.reject(response);
//                 });
//                 return deferred.promise;

//             }
//         };
//     }

//     angular
//         .module('mean.extras')
//         .factory('Extras', Extras);

//     Extras.$inject = ['$http', '$q'];

// })();

'use strict';

angular.module('mean.projects').factory('Extras', ['$resource',
  function($resource) {
    return $resource('/api/extras/:extraId', {
      extraId: '@_id'
    }, {
        update: {
            method: 'PUT'
        },
        bulkAdd: {
            method: 'POST',
            isArray: true
        },
        bulkDelete: {
            method: 'DELETE',
            isArray: true
        }
    });
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/extras/public/services/extras.js